import { tenantConfig, defaultTenantConfig } from '~~/overrides/config'
import { useTenantStore } from '~~/stores/useTenantStore'

export default defineNuxtPlugin(() => {
  const store = useTenantStore()
  try {
    store.setConfig(tenantConfig ?? defaultTenantConfig)
  } catch {
    store.setConfig(defaultTenantConfig)
  }
})
